module.exports = __webpack_public_path__ + "img/arrow-down.6c891f38.svg";